import type { GetNotificationsParams } from '~/api/data-source/notification';
import { notificationRepository } from '~/api/repository/notification';

export const NOTIFICATION_QUERY_KEY = {
  /** 전체 알림 목록 조회 (pagination 없음) */
  all: (category: GetNotificationsParams['category']) => ({
    queryKey: ['/api/market-place/notifications', category] as const,
    queryFn: () =>
      notificationRepository.getNotifications({
        category,
      }),
  }),
};
